import { render, staticRenderFns } from "./pdetailText.vue?vue&type=template&id=80ddfc6c&scoped=true&"
import script from "./pdetailText.vue?vue&type=script&lang=js&"
export * from "./pdetailText.vue?vue&type=script&lang=js&"
import style0 from "./pdetailText.vue?vue&type=style&index=0&id=80ddfc6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ddfc6c",
  null
  
)

export default component.exports